import { render, staticRenderFns } from "./ProfitInfoForm.vue?vue&type=template&id=526766d4&"
import script from "./ProfitInfoForm.vue?vue&type=script&lang=js&"
export * from "./ProfitInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports